import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { SLIDE } from '@bp/shared/animations';

@Component({
	selector: 'bp-toggable-section',
	templateUrl: './toggable-section.component.html',
	styleUrls: [ './toggable-section.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [ SLIDE ],
})
export class ToggableSectionComponent {

	@HostBinding('class.open')
	open = false;

}
